import styled from '@emotion/styled';
import MuiSkeleton, { skeletonClasses } from '@mui/material/Skeleton';
import { DesignsToken } from '@repo/tokens-studio';

const StyledSkeleton = styled(MuiSkeleton)<ISkeletonProps>`
  &.${skeletonClasses.root} {
    background: ${({ theme, background = 'onBackground' }) =>
      theme.color[background]};

    opacity: ${({ theme }) => theme.opacity.semiTransparent};
    margin-inline: ${({ alignment }) => alignment === 'center' && 'auto'};
    margin-left: ${({ alignment }) => alignment === 'right' && 'auto'};
    margin-right: ${({ alignment }) => alignment === 'left' && 'auto'};

    border-radius: ${({ theme, borderRadius }) =>
      theme.shape.corner[borderRadius || '2000']};
  }

  &.${skeletonClasses.rectangular} {
    border-radius: 4px;
  }
`;

export interface ISkeletonProps {
  height?: `${number}%` | 'auto' | number;
  width?: `${number}%` | 'auto' | number;
  borderRadius?: keyof DesignsToken['shape']['corner'];
  background?: keyof DesignsToken['color'];
  alignment?: 'left' | 'center' | 'right';
}

export function Skeleton({
  height = '100%',
  width = '100%',
  background,
  alignment,
  borderRadius,
}: ISkeletonProps) {
  return (
    <StyledSkeleton
      variant="rounded"
      height={height}
      width={width}
      animation="wave"
      alignment={alignment}
      background={background}
      borderRadius={borderRadius}
    />
  );
}
